import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Loader2, Receipt } from "lucide-react";
import api from "@/lib/api";
import { useI18n } from "@/lib/i18n";

export default function MyInvoices({ open, onClose }) {
  const { t } = useI18n();
  const [items, setItems] = useState(null);

  useEffect(() => {
    if (!open) return;
    (async () => {
      try { const { data } = await api.get("/payments/mine"); setItems(data); }
      catch { setItems([]); }
    })();
  }, [open]);

  const download = async (id) => {
    try {
      const res = await api.get(`/payments/invoice/${id}`, { responseType: "blob" });
      const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
      window.open(url, "_blank");
      setTimeout(() => window.URL.revokeObjectURL(url), 10000);
    } catch { /* ignore */ }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-[#111111] border border-white/10 text-white rounded-[16px] max-w-md" data-testid="my-invoices-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-xl font-extrabold flex items-center gap-2">
            <Receipt className="text-[#00E676]" size={20} /> {t("my_invoices")}
          </DialogTitle>
        </DialogHeader>
        {items === null ? (
          <div className="py-8 text-center text-white/40"><Loader2 className="animate-spin inline" /></div>
        ) : items.length ? items.map((p) => (
          <div key={p.id} data-testid={`invoice-${p.id}`} className="flex items-center justify-between py-2.5 border-b border-white/5 last:border-0">
            <div>
              <div className="text-sm text-white/90">{p.label}</div>
              <div className="text-white/40 text-xs">{(p.created_at || "").slice(0, 10)} · {(p.amount_ttc || 0).toFixed(2)} €</div>
            </div>
            <Button data-testid={`download-invoice-${p.id}`} onClick={() => download(p.id)} variant="outline"
              className="border-[#00E676]/40 text-[#00E676] hover:bg-[#00E676]/10 rounded-[12px] h-8 text-xs">
              <Receipt size={13} className="mr-1" /> {t("download")}
            </Button>
          </div>
        )) : <div className="text-white/40 text-sm py-6 text-center">{t("no_invoices")}</div>}
      </DialogContent>
    </Dialog>
  );
}
